module.exports = __webpack_public_path__ + "static/media/bm.07a8c1ea.webp";